import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Sidebar } from '@/app/layouts/sidebar/Sidebar';

interface AppLayoutProps {
  children: ReactNode;
}

const LAYOUT_EDITOR_PATH = /^\/elabel\/layouts\/[^/]+$/;

export const AppLayout = ({ children }: AppLayoutProps) => {
  const { pathname } = useLocation();
  const isLayoutEditor = LAYOUT_EDITOR_PATH.test(pathname);

  return (
    <div className="flex max-h-dvh">
      <div
        aria-hidden
        className="fixed inset-x-0 top-0 z-40 h-[env(safe-area-inset-top)] bg-surface"
      />
      {isLayoutEditor ? null : <Sidebar />}
      <div className="flex flex-col max-w-full grow items-start">
        <div className="prose max-w-full min-w-0 w-full grow overflow-x-clip overflow-y-auto px-4 pb-4 pt-[calc(1rem+env(safe-area-inset-top))]">
          <main className="w-full">{children}</main>
        </div>
      </div>
    </div>
  );
};
